import md5 from 'js-md5';

const Profile = () => {
  window.md5 = window.md5 || md5;

  return null;
};

export default Profile;
